import { PrintSampleScope } from "./types";

export const PrintSamplePaths: Record<PrintSampleScope, string> = {
  [PrintSampleScope.Salary13th]: "/pyr/13th/print-samples",
  [PrintSampleScope.KpiIndividual]: "/pyr/kpi-individuals/print-samples",
  [PrintSampleScope.KpiDepartment]: "/pyr/kpi-departments/print-samples",
};

export default PrintSamplePaths;
